import { Component, OnInit, ViewChild, ViewChildren, ElementRef } from '@angular/core';
import {place_map_lang} from "../../language/place_map";
import { ActivatedRoute, Router } from '@angular/router';
import { MyserviceService } from '../../provider/myservice.service';
import {map} from './../../global/style';

import Swal from 'sweetalert2';
import OlMap from "ol/map";
import OlTileWMS from "ol/source/TileWMS";
import OlTileLayer from "ol/layer/tile";
import OlView from "ol/View";
// import VectorSource from "ol/source/Vector";
// import VectorLayer from "ol/layer/Vector";
import Point from 'ol/geom/Point.js';
// import Feature from 'ol/Feature';
import Icon from 'ol/style/icon';
// import Style from 'ol/style/Style';
// import GeoJSON from 'ol/format/GeoJSON';
import { Tooltip } from 'chart.js';
import Overlay from "ol/Overlay";
import { PopoverConfig } from 'ngx-bootstrap/popover';
declare var ol: any;
import * as $ from 'jquery';
import * as moment from 'moment';
import 'ol/ol.css';
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import View from 'ol/View';
import GeoJSON from 'ol/format/GeoJSON';
import Circle from 'ol/geom/Circle';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {OSM, Vector as VectorSource} from 'ol/source';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';

import ResizeObserver from 'resize-observer-polyfill';
@Component({
  selector: 'app-place-map',
  templateUrl: './place-map.component.html',
  styleUrls: ['./place-map.component.scss']
})
export class PlaceMapComponent implements OnInit {
  lang=localStorage.getItem('lang')=="EN"?"EN":"TH";
  language:any;
  map: OlMap;
  source: OlTileWMS;
  layer: OlTileLayer;
  view: OlView;
  markerSource: VectorSource;
  customers:any;
  customer_places:any=[];
  customer_place:any="all";
  isSelected=true;
  @ViewChildren('divId')  A;
  public agNote: ElementRef;
  show_map=false;
  users:any=[];
  geojson:any;
  constructor(private route: ActivatedRoute, private router: Router,private service:MyserviceService) { }
  customer_id="";
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=place_map_lang[this.lang];
      }else{
        this.language=place_map_lang[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });
   this.get_customer();
   this.service.postData({},"market-place/get").then((result:any)=>{
    if(!result.code){
      this.geojson=result.data;
      this.service.postData({},"get_user").then((result:any)=>{
        //console.log(result);
        this.users=result.data.filter(item=>{
          return item.lat&&item.lon
        }).map((item:any)=>{
          // var date=new Date(item.lastlogin);
          item.active=false;
          var date1=new Date().getTime();
          var login=new Date(item.lastlogin).getTime();
          if((date1-login)/1000<30*60){
            item.active=true;
          }
          if(item.lastlogin!='null' && item.lastlogin!=null && item.lastlogin!=""){
            item.lastlogin=moment(item.lastlogin).format("DD/MM/YYYY HH:mm:ss");
          }

          return item;
        });
        this.draw_map()
      })

    }

   })
  }
  onResize(event) {
    alert(event.target.innerWidth);
  }
  get_customer(){
    this.service.postData({},"customer/get").then((result:any)=>{
      if(!result.code){
        this.customers=result.data;
      }
    })
  }
  getCustomer_place(){
    // alert(11);
    this.service.postData({customer_id:this.customer_id},"customer-place/get_place").then((result:any)=>{
      this.customer_places=result.data.map((item)=>{

        item.selected=true;
        return item;
      });
      this.isSelected=true;
      this.show_map1();
    },err=>{
      window.location.href=this.service.start_host
    })
  }
  focus(place){
    this.map.getView().setCenter(ol.proj.transform( [place.lon,place.lat],
      "EPSG:4326",
      "EPSG:900913"));
      this.map.getView().setZoom(18);
  }
  changeItem(place){
    place.selected=!place.selected;
    // alert(11);
    var x=this.customer_places.filter((item)=>item.selected);
    // //console.log(this.customer_places);
    // //console.log(x);
    if(x.length==this.customer_places.length){
      this.isSelected=true;

    }else{
      this.isSelected=false;
    }
    this.show_map1();
  }
  selectAll(){
    // alert(this.isSelected);
    this.customer_places=this.customer_places.map((item)=>{
      item.selected=!this.isSelected;
      return item;

    })
    this.show_map1();
  }
  show_map1(){
    this.show_map=false;
      setTimeout(()=>{
        this.show_map=true;
      },100);
      setTimeout(()=>{
        this.draw_map();
      },200);
  }
  draw_map(){


    this.map =map(
      this.geojson!=null?JSON.parse(JSON.stringify(this.geojson)):null
    ,'map')
    this.map.render();
    var iconStyle = new Style({
      image: new Icon({
        anchor: [0.5, 0.5],
        scale: 1,
        src: '/assets/img/marker.png',
        crossOrigin: "Anonymous",
      })
    })
    var markers=[];
    //console.log(this.customer_places);
    this.customer_places.filter((item)=>item.selected).forEach((customer_place)=>{
        var marker = new Overlay({
          position: ol.proj.fromLonLat([parseFloat(customer_place.lon), parseFloat(customer_place.lat)]),
          positioning: 'center-center',
          element: document.getElementById(customer_place.place_id),
          stopEvent: false
        });
        this.map.addOverlay(marker);

      })
      this.users.forEach((user)=>{
        var marker = new Overlay({
         position: ol.proj.fromLonLat([parseFloat(user.lon), parseFloat(user.lat)]),
         positioning: 'center-center',
         element: document.getElementById(user.user_id),
         stopEvent: false
       });
       this.map.addOverlay(marker);
     })



  //   var feature = this.markerSource.getFeatures()
  //   for (let i in feature) {
  //     this.markerSource.removeFeature(feature[i])
  // }
}

}
